module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( context === "test" ) { 
__p+=' <p>'+
((__t=( i18n.tc("UnitTests", "Running device tests, please wait...") ))==null?'':__t)+
'<br> '+
((__t=( i18n.tc("UnitTests", "This may take several minutes.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "wait" ) { 
__p+=' <p>'+
((__t=( i18n.tc("Config", "Please wait ...") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "device" ) { 
__p+=' <p>'+
((__t=( i18n.tc("Config", "Please wait while the device is being configured.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "migrate" ) { 
__p+=' <p>'+
((__t=( i18n.tc("Config", "Your device is being migrated, please wait.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( context === "update" ) { 
__p+=' <p>'+
((__t=( i18n.tc("Config", "Your device is being updated, this may take up to 20 minutes.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' <div class="progress indeterminate"><div class="bar progress-bar"></div><div class="bar buffer-bar"></div><div class="bar aux-bar"></div></div>';
}
return __p;
};
